import { useRoutes } from 'react-router-dom';

// routes
import MainRoutes from './MainRoutes';
import NoshBagRoutes from './NoshBagRoutes';
import AuthenticationRoutes from './AuthenticationRoutes';
import OrderRoutes from './OrderRoutes';
// import config from 'config';

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
    return useRoutes([AuthenticationRoutes, MainRoutes, NoshBagRoutes, OrderRoutes]);
}
